function getLabel(city, state) {
  if (state !== "" && state !== undefined) return city + "," + state;
  else return city;
}
export default getLabel;
